<template>
  <div>
    <div class="header" :class="{fixed_header: isFixedHeader}">
      <div>
        <div class="logo">
          <div @click="toHome()">
            <img src="../assets/img/logo.png" alt="官网" />
          </div>
          <div class="name">湘潭市政府采购合同融资信息服务平台</div>
        </div>
        <div class="head-nav">
          <ul>
            <li v-for="(item,index) in titleList" :key="index" @click="selectedNav(item)">
              <router-link :to="item.link" :class="{active: active == item.title}">{{ item.title }}</router-link>
            </li>
          </ul>

          <div class="btn">
            <a href="http://xt.zcd.guoguyun.com/zcd/page/account/register.html" target="_blank" class="lnk-default lnk-small">注册</a>
            <a href="http://xt.zcd.guoguyun.com/zcd/" target="_blank" class="lnk-default lnk-small lnk-two">登录</a>
          </div>

          <i class="el-icon-menu i-custom" @click="drawer = true" style="font-size: 28px;margin-top: 4px"></i>
        </div>
      </div>
    </div>

    <el-drawer title="快捷导航" :visible.sync="drawer" size="300px" class="right-pop-box">
      <div class="drawer-box">
        <ul class="drawer-nav">
          <li v-for="(item,index) in titleList" :key="index" @click="selectedNav(item)">
            <router-link :to="item.link" :class="{active: active == item.title}">{{ item.title }}</router-link>
          </li>
        </ul>
        <div class="btn">
          <a href="http://xt.zcd.guoguyun.com/zcd/page/account/register.html" target="_blank" class="lnk-default">注册</a>
          <a href="http://xt.zcd.guoguyun.com/zcd/" target="_blank" class="lnk-default lnk-two">登录</a>
        </div>
      </div>
    </el-drawer>

    <!--返回顶部-->
    <el-backtop></el-backtop>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      isFixedHeader: false,
      active: '首页',
      titleList:[
        {
          title: '首页',
          link: '/index'
        },
        {
          title: '采购信息',
          link: '/notice'
        },
        {
          title: '采购合同',
          link: '/contract'
        },
        {
          title: '融资超市',
          link: '/product'
        },
        {
          title: '新闻报道',
          link: '/news'
        },
      ],
      drawer: false
    };
  },
  created() {},
  mounted() {
    // 事件监听滚动条
    window.addEventListener('scroll', this.handleScroll);
    //
    this.active = this.$route.meta.nav;
  },
  destroyed() {
    // 移除事件监听
    // window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 当元素滚动条被滚动时运行的脚本
    handleScroll() {
      // 滚动的距离
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop; //这里的判断是为了兼容各个浏览器
      if (scrollTop > 100) {
        this.isFixedHeader = true;
      } else {
        this.isFixedHeader = false;
      }
    },
    // 导航切换
    selectedNav(item){
      this.active = item.title;
      if(!item.link){
        this.$notify({
          title: '提示',
          message: '逐步开放中。',
          type: 'info',
          offset: 80
        });
      }
    },
    toHome(){
      this.$router.push({name:'index'});
      this.active = '首页';
    }
  }
};
</script>

<style lang="scss">

  .right-pop-box {
    /* 隐藏标题框 */
    .el-drawer__header {
      span {
        outline: none;
      }
    }
    /* 显示滚动条 */
    .el-drawer__body {
      overflow: auto;
    }
    /* 隐藏滚动条 */
    .el-drawer__container ::-webkit-scrollbar {
      display: none;
    }
  }
</style>
<style lang="scss" scoped>
  $white: #ffffff;
  @mixin rim {
    background: transparent none repeat scroll 0 0;
    content: "";
    height: 10px;
    position: absolute;
    width: 25px;
    visibility: hidden;
    transition: .3s ease;
    opacity: 0;
  }
  .header {
    color: $white;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    padding: 2% 0;
    background: transparent;
    transition: background-color 0.8s;
    &>div {
      display: flex;
      justify-content: space-between;
      margin: 0 2%;
      /*.img_hover:hover {
        &::before {
          content: "";
          height: 555px;
          width: 100%;
          position: absolute;
          left: 0%;
          top: 0;
          background-color: transparent;
          background-image: -webkit-linear-gradient(-30deg, transparent 30%, #fff 50%, transparent 70%); !*设置渐变的背景，按对角线渐变*!
          background-blend-mode: hard-light; !*设置背景为混合模式下的强光模式*!
          background-size: 200%;
          animation: shine 5s forwards; !*给背景添加动画改变位置*!
        }
      }*/
      .logo {
          margin-left: 120px;
          display: flex;
          align-items: center;
        img {
          /*position: absolute;*/
          z-index: inherit;
          cursor: pointer;
          vertical-align: middle;
        }
        .name {
          padding: 5px 15px;
          background: rgba(0, 0, 0, 0.1);
          border-radius: 20px;
          font-weight: bold;
          color: $white;
          margin-left: 20px;
        }
      }
      .head-nav {
        display: flex;
        justify-content: right;

        ul {
          font-weight: bold;
          display: flex;
          list-style: none;
          /*flex-grow: 1;*/
          justify-content: right;
          li {
            margin-left: 10px;
            box-sizing: border-box;
            position: relative;
            a {
              display: block;
              line-height: 20px;
              padding: 6px 15px;
              text-decoration:none;
              box-sizing: border-box;
              color: $white;
              position: relative;
              background-color: transparent;
              text-transform: uppercase;
              transition: .3s ease;
              font-size: 18px;
              &.active {
                color: #fff;
                &::before {
                  visibility: visible;
                  opacity: .6;
                  left: 0;
                }
                &::after {
                  visibility: visible;
                  opacity: .6;
                  right: 0;
                }
              }
              &:hover {
                background: none;
                color: #fff;
                outline: none;
                &::before {
                  visibility: visible;
                  opacity: .6;
                  left: 0;
                }
                &::after {
                  visibility: visible;
                  opacity: .6;
                  right: 0;
                }
              }
              &::before{
                @include rim;
                border-left: 1px solid #fff;
                border-top: 1px solid #fff;
                top: 0;
                left: -70px;
              }
              &::after {
                @include rim;
                border-right: 1px solid #fff;
                border-bottom: 1px solid #fff;
                bottom: 0;
                right: 70px;
              }
            }
          }
        }

        .i-custom {
          display: none;
        }
      }
    }
  }
  .fixed_header {
    background: #055084;
    filter: alpha(opacity=95);
    box-shadow:0 4px 12px 0 rgba(52, 63, 75, .06);
    padding: 10px 0;
  }

  .drawer-box {
    text-align: center;
    .drawer-nav {
      padding: 0 30px;
      li {
        /*border-bottom: 1px solid #383b3f;*/
        position: relative;
        margin-bottom: 10px;
        a {
          display: block;
          line-height: 20px;
          padding: 6px 15px;
          text-decoration:none;
          box-sizing: border-box;
          color: #336FDC;
          position: relative;
          background-color: transparent;
          text-transform: uppercase;
          transition: .3s ease;
          font-size: 14px;
          &.active {
            color: #336FDC;
            &::before {
              visibility: visible;
              opacity: 1;
              left: 0;
            }
            &::after {
              visibility: visible;
              opacity: 1;
              right: 0;
            }
          }
          &:hover {
            background: none;
            color: #336FDC;
            outline: none;
            &::before {
              visibility: visible;
              opacity: 1;
              left: 0;
            }
            &::after {
              visibility: visible;
              opacity: 1;
              right: 0;
            }
          }
          &::before{
            @include rim;
            border-left: 1px solid #336FDC;
            border-top: 1px solid #336FDC;
            top: 0;
            left: -70px;
          }
          &::after {
            @include rim;
            border-right: 1px solid #336FDC;
            border-bottom: 1px solid #336FDC;
            bottom: 0;
            right: 70px;
          }
        }
      }
    }
    .btn {
      background: #336FDC;
      display: block;
      text-align: center;
      padding: 10px;
      margin-top: 30px;
      a {
        height: 28px;
        line-height: 28px;
      }
    }
  }


  // 动画
  /*@keyframes shine {
    from {background-position: 130%;}
    to {background-position: -50%;}
  }*/
  @media screen and (max-width: 1132px) {
    .header {
      ul , .btn{
        display: none !important;
      }
      .i-custom {
        display: inline-block !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue